import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** WHP = GPM·TDH/3960 — pump with suction & discharge gauges, TDH column, affinity mini-chart. */
export function DiagramPumpLawsWaterHP() {
  // Pump volute
  const px = 135, py = 125, pr = 32;

  return (
    <DiagramCanvas>
      {/* Suction pipe + tank reservoir */}
      <Rect x={20} y={150} width={46} height={70} fill="none" stroke={DT.stroke} strokeWidth="1.4" />
      <Line x1={20} y1={158} x2={66} y2={158} stroke="rgba(122,170,187,0.5)" strokeWidth="3" />
      <Line x1={20} y1={164} x2={66} y2={164} stroke="rgba(122,170,187,0.3)" strokeWidth="2" />
      <SvgText x={43} y={215} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">source</SvgText>
      <Line x1={43} y1={158} x2={43} y2={130} stroke={DT.stroke} strokeWidth="6" />
      <Line x1={43} y1={130} x2={px - pr} y2={130} stroke={DT.stroke} strokeWidth="6" />

      {/* Pump (centrifugal) */}
      <Circle cx={px} cy={py} r={pr} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      <Path d={`M${px - pr},${py} A${pr},${pr} 0 1 1 ${px},${py + pr} L${px + pr + 8},${py + pr} L${px + pr + 8},${py + pr - 10}`}
        fill="none" stroke={DT.stroke} strokeWidth="1.2" />
      {[0, 60, 120, 180, 240, 300].map(d => {
        const r = d * Math.PI / 180;
        return <Line key={d} x1={px + 5 * Math.cos(r)} y1={py + 5 * Math.sin(r)}
          x2={px + 22 * Math.cos(r + 0.4)} y2={py + 22 * Math.sin(r + 0.4)}
          stroke={DT.stroke} strokeWidth="1.3" />;
      })}
      <Circle cx={px} cy={py} r={4} fill={DT.stroke} />

      {/* Suction gauge (P1) */}
      <Circle cx={75} cy={110} r={11} fill={DT.fill} stroke={DT.leader} strokeWidth="1.4" />
      <SvgText x={75} y={114} fill={DT.leader} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">P₁</SvgText>
      <Line x1={75} y1={121} x2={75} y2={130} stroke={DT.leader} strokeWidth="0.8" strokeDasharray="2,2" />

      {/* Discharge pipe rising */}
      <Line x1={px + pr + 8} y1={py + pr - 10} x2={px + pr + 8} y2={60} stroke={DT.stroke} strokeWidth="6" />
      <Line x1={px + pr + 8} y1={60} x2={260} y2={60} stroke={DT.stroke} strokeWidth="6" />
      <Polygon points={`256,60 248,56 248,64`} fill={DT.arrow} />

      {/* Discharge gauge (P2) */}
      <Circle cx={200} cy={40} r={11} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <SvgText x={200} y={44} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">P₂</SvgText>
      <Line x1={200} y1={51} x2={200} y2={60} stroke={DT.leader} strokeWidth="0.8" strokeDasharray="2,2" />

      {/* TDH vertical dimension (right side) */}
      <Line x1={290} y1={60} x2={290} y2={130} stroke={DT.varColor} strokeWidth="1.2" />
      <Polygon points={`290,60 286,66 294,66`} fill={DT.varColor} />
      <Polygon points={`290,130 286,124 294,124`} fill={DT.varColor} />
      <Line x1={260} y1={60} x2={295} y2={60} stroke={DT.dim} strokeWidth="0.7" strokeDasharray="2,2" />
      <Line x1={66} y1={130} x2={295} y2={130} stroke={DT.dim} strokeWidth="0.4" strokeDasharray="2,2" />
      <SvgText x={306} y={98} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} fontWeight="700">TDH</SvgText>
      <SvgText x={306} y={110} fill={DT.desc} fontSize="7" fontFamily={DT.mono}>(ft)</SvgText>

      {/* Affinity mini card */}
      <Rect x={20} y={40} width={70} height={42} fill="rgba(0,0,0,0.45)" stroke={DT.dim} strokeWidth="0.8" />
      <SvgText x={55} y={51} fill={DT.desc} fontSize="7" fontFamily={DT.mono} textAnchor="middle">affinity</SvgText>
      <SvgText x={55} y={62} fill={DT.varColor} fontSize="7" fontFamily={DT.mono} textAnchor="middle">Q∝N  H∝N²</SvgText>
      <SvgText x={55} y={74} fill={DT.varColor} fontSize="7" fontFamily={DT.mono} textAnchor="middle">BHP∝N³</SvgText>

      {/* Labels */}
      <LeaderLine x1={43} y1={150} x2={20} y2={230} varName="GPM" desc="flow rate" anchor="start" />
      <LeaderLine x1={290} y1={95} x2={320} y2={210} varName="TDH" desc="total dyn. head" anchor="end" />
      <LeaderLine x1={px} y1={py + pr} x2={150} y2={230} varName="WHP" desc="water horsepower" anchor="middle" />

      <FormulaTag formula="WHP = GPM · TDH / 3960   (Q/Q' = N/N', H/H' = (N/N')²)" />
    </DiagramCanvas>
  );
}
